import { useMemo } from 'react';
import { AppSourceType, CommonEventData, UserCaseType } from '@kueski-analytics/events/home';
import useProtectedApplication from './useProtectedApplication';
import useInteractionChannel from './useInterationChannel';
import useGetConsumerType from './useGetConsumerType';
import useScreenName from './useScreenName';

export default function useCommonHomeEventFields() {
  const { data: application, isLoading: isApplicationLoading } = useProtectedApplication();
  const { data: consumerTypeData, isLoading: isConsumerTypeLoading } = useGetConsumerType();
  const screen = useScreenName();
  const interactionChannel = useInteractionChannel();

  const commonFields = useMemo(() => {
    const fields: CommonEventData = {
      app_source: AppSourceType.KPAY,
      case: UserCaseType.Normal,
      interaction_channel: interactionChannel,
      kueski_user_id: application?.customer_id ?? '',
      origin_screen: screen,
      user_type: consumerTypeData?.user_type ?? 'indeterminate',
    };

    return fields;
  }, [interactionChannel, application?.customer_id, consumerTypeData?.user_type, screen]);

  const isLoading = isApplicationLoading || isConsumerTypeLoading;

  return { commonFields, isLoading };
}
